import styled from 'styled-components';

export const ErrorMessage = styled.p`
  margin-top: 5px;

  color: var(--red);
  font-size: var(--font-size-smlr);
`;
